export default "__VITE_PUBLIC_ASSET__f4580e2c__"